import { authHeader, authHeaderForm } from '../../helpers/auth-header';
import showErrorMessage from '../../helpers/showErrorMessage';
import { client } from '../../actions';
import { requestListConstants } from './request-list.constants';
import { requestsConstants } from './requests.constants';
import moment from 'moment';
import changeRequestCreationMethod from '../../requests/changeRequestCreationMethod';
import { changeRequestPriority } from '../../requests/changeRequestPriority';
import { changeRequestDescriptionExt } from '../../requests/changeDescriptionExt';
import { getUpdatedRequest } from '../../helpers/requestUtils';
import { changeRequestControlDate } from '../../requests/changeRequestControlDate';

const url = '/Request';

export const requestListActions = {
  setRecordsRequest,
  setAttachmentRequest,
  setRequestStatus,
  setRequestCreationMethod,
  setRequestPriority,
  setRequestMark,
  setRequestWaiting,
  setRequestRating,
  setSelected,
  setSelectedRequest,
  setPageSize,
  setRequestDescription,
  setRequestHasRecord,
  setRequestDescriptionExt,
  markRequestViewed,
  markRequestCommented,
  openInvoiceModal,
  closeInvoiceModal,
  openHistory,
  closeHistory,
  openMap,
  closeMap,
  setRequestFavorite,
  retrieveLastState,
  setRequestControlDate,
};

function openHistory(v) {
  return (dispatch) => {
    dispatch({
      type: requestsConstants.HISTORY_OPEN,
      payload: v,
    });
  };
}

function closeHistory() {
  return (dispatch) => {
    dispatch({
      type: requestsConstants.HISTORY_CLOSE,
    });
  };
}

function openMap(v) {
  return (dispatch) => {
    dispatch({
      type: requestsConstants.MAP_OPEN,
      payload: v,
    });
  };
}

function closeMap() {
  return (dispatch) => {
    dispatch({
      type: requestsConstants.MAP_CLOSE,
    });
  };
}

function openInvoiceModal(v) {
  return (dispatch) => {
    dispatch({
      type: requestsConstants.OPEN_INVOICE_MODAL,
      payload: v,
    });
  };
}

function closeInvoiceModal() {
  return (dispatch) => {
    dispatch({
      type: requestsConstants.CLOSE_INVOICE_MODAL,
    });
  };
}

function setRequestHasRecord(requestId) {
  return (dispatch, getState) => {
    const requestsClone = getState().requestsStore.requests.slice();

    const updatedRequestIndex = requestsClone.findIndex(
      (request) => request.id === requestId
    );

    if (updatedRequestIndex !== -1) {
      requestsClone[updatedRequestIndex].hasRecord = true;

      dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: requestsClone,
      });
    }
  };
}

function setRequestDescription(requestId, value) {
  return (dispatch, getState) => {
    const rurl = url + '/set_description/' + requestId;
    const data = value.replace(/"/g, '\\"');

    client.put(rurl, `"${data}"`, { headers: authHeader() }).then(() => {
      const rl = getState().requestsStore.requests.slice();
      const ri = rl.findIndex((el) => el.id === requestId);
      rl[ri].description = value.replace(/"/g, '"');

      dispatch({
        type: requestsConstants.SET_REQUEST_STATUS,
        payload: new Promise((resolve) => {
          resolve({ data: rl });
        }),
      });
    });
  };
}

function setRequestDescriptionExt({ requestId, description, showToClient }) {
  return async (dispatch, getState) => {
    console.log(requestId, 'requestId');
    const res = await changeRequestDescriptionExt({
      requestId,
      description,
      showToClient,
    });

    if (res !== 'Error') {
      const rl = getState().requestsStore.requests.slice();
      const newRequestsArr = rl.map((newRequestsItem) => {
        if (newRequestsItem.id === requestId) {
          newRequestsItem.showToClient = showToClient;
        }
        return newRequestsItem;
      });
      dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: newRequestsArr,
      });
    }
  };
}

function setSelected(val) {
  return (dispatch) => {
    dispatch({
      type: requestListConstants.SET_SELECTED_ROWS,
      payload: val,
    });
  };
}

function setSelectedRequest({ request }) {
  return (dispatch) => {
    dispatch({
      type: requestListConstants.SET_SELECTED_ROW,
      payload: request,
    });
  };
}

function setPageSize(val) {
  return (dispatch) => {
    localStorage.setItem('dspxPageSize', JSON.stringify(val));
    dispatch({
      type: requestListConstants.SET_PAGE_SIZE,
      payload: val,
    });
  };
}

function setRequestCreationMethod({ requestId, method }) {
  return async (dispatch, getState) => {
    const res = await changeRequestCreationMethod({
      requestId,
      methodId: method.id,
    });

    if (res.result === 'Ok') {
      const rl = getState().requestsStore.requests.slice();
      const newRequestsArr = rl.map((newRequestsItem) => {
        if (newRequestsItem.id === requestId) {
          newRequestsItem.creationMethod = method;
        }
        return newRequestsItem;
      });
      dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: newRequestsArr,
      });
    }
  };
}

function setRequestPriority({ requestId, priority }) {
  return async (dispatch, getState) => {
    const res = await changeRequestPriority({
      requestId,
      priorityId: priority.id,
    });
    // При успешном запросе, бекенд отдаёт пустую строку
    if (res !== 'Error') {
      const rl = getState().requestsStore.requests.slice();
      const newRequestsArr = rl.map((newRequestsItem) => {
        if (newRequestsItem.id === requestId) {
          if (priority.id === 0) {
            delete newRequestsItem.priority;
          } else {
            newRequestsItem.priority = priority;
          }
        }
        return newRequestsItem;
      });
      dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: newRequestsArr,
      });
    }
  };
}

function setRequestControlDate({ requestId, date }) {
  return async (dispatch, getState) => {
    const res = await changeRequestControlDate({
      requestId,
      value: date,
    });
    if (res !== 'Error') {
      const rl = getState().requestsStore.requests.slice();
      const newRequestsArr = rl.map((newRequestsItem) => {
        if (newRequestsItem.id === requestId) {
          newRequestsItem.alertDate = !!date ? date : null;
        }
        return newRequestsItem;
      });
      dispatch({
        type: requestsConstants.UPDATE_REQUESTS,
        payload: newRequestsArr,
      });
    }
  };
}

function setRequestMark(requestId, mark, value) {
  return (dispatch, getState) => {
    const rurl = url + '/set_' + mark + '/' + requestId;

    client.put(rurl, value, { headers: authHeader() }).then(() => {
      const rl = getState().requestsStore.requests.slice();
      const ri = rl.findIndex((el) => el.id === requestId);
      if (mark == 'immediate') rl[ri].isImmediate = value == 1;
      else if (mark == 'chargeable') rl[ri].isChargeable = value == 1;
      else if (mark == 'internal')
        rl[ri].isInternal = value.IsInternal === true;

      dispatch({
        type: requestsConstants.SET_REQUEST_STATUS,
        payload: new Promise((resolve) => {
          resolve({ data: rl });
        }),
      });
    });
  };
}

function setRequestWaiting(requestId, isWaiting, comment) {
  return async (dispatch, getState) => {
    try {
      await client.put(
        `${url}/set_waiting/${requestId}`,
        { IsWaiting: isWaiting, Note: comment },
        { headers: authHeader() }
      );
    } catch (error) {
      showErrorMessage(error, 'Не удалось изменить признак "Ожидание"');
      return false;
    }

    const rl = getState().requestsStore.requests.map((el) => {
      if (el.id !== requestId) return el;
      return  { ...el, isWaiting };
    });

    dispatch({
      type: requestsConstants.SET_REQUEST_STATUS,
      payload: new Promise((resolve) => {
        resolve({ data: rl });
      }),
    });

    return true;
  };
}

function setRequestFavorite(request) {
  return async (dispatch, getState) => {
    const isFavor = !request.favorites;
    const rurl = `/Request/favorites/${request.id}`;

    try {
      const res = isFavor
        ? await client.put(rurl, request.id, { headers: authHeader() })
        : await client.delete(rurl, { headers: authHeader() });

      if (res.status == 200) {
        const rl = getState().requestsStore.requests.slice();
        const ri = rl.findIndex((el) => el.id === request.id);
        rl[ri].favorites = isFavor;

        const filter = getState().requestsStore.favorites;
        if (filter && !isFavor) {
          rl.splice(ri, 1);
        }

        dispatch({
          type: requestsConstants.SET_REQUEST_STATUS,
          payload: new Promise((resolve) => {
            resolve({ data: rl });
          }),
        });
      }
    } catch (err) {}
  };
}

function setRequestStatus(requestId, statusId, statusDescr) {
  return (dispatch, getState) => {
    const rurl = url + '/status/' + requestId;

    client.put(rurl, statusId, { headers: authHeader() }).then(async () => {
      const updatedRequest = await getUpdatedRequest(requestId);

      if (updatedRequest) {
        const rl = getState().requestsStore.requests.map((request) =>
          request.id === requestId ? updatedRequest : request
        );

        dispatch({
          type: requestsConstants.SET_REQUEST_STATUS,
          payload: Promise.resolve({ data: rl }),
        });
      }
    });
  };
}

function setRequestRating(requestId, ratingId, update) {
  return (dispatch, getState) => {
    const rurl = url + '/set_rating/' + requestId;

    client.put(rurl, ratingId, { headers: authHeader() }).then(() => {
      const rl = getState().requestsStore.requests.slice();
      const ri = rl.findIndex((el) => el.id === requestId);
      //rl[ri].status = statusDescr;
      rl[ri].rating = ratingId;

      dispatch({
        type: requestsConstants.SET_REQUEST_RATING,
        payload: new Promise((resolve) => {
          resolve({ data: rl });
        }),
      });
    });
  };
}

function setRecordsRequest(val) {
  return (dispatch) => {
    dispatch({
      type: requestListConstants.SET_RECORDS_REQUEST,
      payload: val,
    });
  };
}

function setAttachmentRequest(val) {
  return (dispatch) => {
    dispatch({
      type: requestListConstants.SET_ATTACHMENTS_REQUEST,
      payload: val,
    });
  };
}

function markRequestViewed(requestId) {
  return (dispatch, getState) => {
    let rurl = url + '/view_request';

    client
      .post(rurl, requestId, { headers: authHeader() })
      .then(function (response) {
        const rl = getState().requestsStore.requests.slice();
        const ri = rl.findIndex((el) => el.id === requestId);
        rl[ri].firstViewDate = moment();

        dispatch({
          type: requestsConstants.MARK_REQUEST_VIEWED,
          payload: new Promise((resolve) => {
            resolve({ data: rl });
          }),
        });
      })
      .catch(function (error) {
        console.log(error);
        dispatch({
          type: 'requestsConstants.POST_ERROR',
          payload: error,
        });
      });
  };
}

function markRequestCommented(requestId) {
  console.log('====================================== markRequestCommented');
  return (dispatch, getState) => {
    const rl = getState().requestsStore.requests.slice();
    const ri = rl.findIndex((el) => el.id === requestId);
    rl[ri].existNote = true;

    dispatch({
      type: requestsConstants.MARK_REQUEST_COMMENTED,
      payload: new Promise((resolve) => {
        resolve({ data: rl });
      }),
    });
  };
}

function retrieveLastState(state) {
  return (dispatch) => {
    dispatch({
      type: requestListConstants.RETRIEVE_LAST_STATE,
      payload: state,
    });
  };
}
